// @file Types for slideshow

import type { Post } from '@@/types'

enum PageType {
  Cover = 'cover',
  Section = 'section',
  Group = 'group',
  Post = 'post',
}

interface Page {
  pageType: PageType
  entityId?: string
}

interface SlideshowPostListItem {
  pageIndex: number
  pageType: PageType
  subject: string
  body: string | null
  post: Post | null
}
export { PageType }
export type { Page, SlideshowPostListItem }
